import Api from "./Api";
import { FeaturedArticle } from "../types";

export default class FeaturedArticlesController extends Api {
  static getArticles(helpCenterId: string) {
    return fetch(`/api/help_centers/${helpCenterId}/featured_articles`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }
  static create(helpCenterId: string, featuredArticle: FeaturedArticle) {
    return fetch(`/api/help_centers/${helpCenterId}/featured_articles`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ featured_article: featuredArticle }),
    }).then((res) => res.json());
  }

  static update(helpCenterId: string, featuredArticle: FeaturedArticle) {
    return fetch(
      `/api/help_centers/${helpCenterId}/featured_articles/${featuredArticle.id}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
        body: JSON.stringify({ featured_article: featuredArticle }),
      }
    ).then((res) => res.json());
  }

  static delete(helpCenterId: string, id: string) {
    return fetch(`/api/help_centers/${helpCenterId}/featured_articles/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }
}
